import { snackbarTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Project } from '@experiment-management-shared/types';

const useShowPublicViewChangedNotification = () => {
  const shown = useRef(false);
  const dispatch = useDispatch();

  const showPublicViewChangedNotification = useCallback(
    (project: Project) => {
      if (shown.current) return;

      dispatch(
        alertsUtil.openSnackbarDialog(
          snackbarTypes.SUCCESS_API_RESPONSE,
          `You have read-only access to “${project.projectName}”. Your changes will not be saved.`
        )
      );

      shown.current = true;
    },
    [dispatch]
  );

  const showViewModifiedByAnotherNotification = useCallback(() => {
    dispatch(
      alertsUtil.openSnackbarDialog(
        snackbarTypes.SUCCESS_API_RESPONSE,
        `Your changes can’t be applied. The view has been modified by somebody else.`
      )
    );
  }, [dispatch]);

  return {
    showPublicViewChangedNotification,
    showViewModifiedByAnotherNotification
  };
};

export default useShowPublicViewChangedNotification;
